/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
  TelegramParametersControllerFindDynamicParametersByOptionPathParams,
  TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
} from '../types/TelegramParametersControllerFindDynamicParametersByOption.ts';

function getTelegramParametersFindDynamicParametersByOptionUrl(
  id: TelegramParametersControllerFindDynamicParametersByOptionPathParams['id'],
  categoryId: TelegramParametersControllerFindDynamicParametersByOptionPathParams['categoryId'],
) {
  const res = { method: 'GET', url: `/api/telegram/parameters/${id}/dynamic/${categoryId}` as const };
  return res;
}

/**
 * {@link /api/telegram/parameters/:id/dynamic/:categoryId}
 */
export async function telegramParametersFindDynamicParametersByOption(
  id: TelegramParametersControllerFindDynamicParametersByOptionPathParams['id'],
  categoryId: TelegramParametersControllerFindDynamicParametersByOptionPathParams['categoryId'],
  params: TelegramParametersControllerFindDynamicParametersByOptionQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramParametersControllerFindDynamicParametersByOptionQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getTelegramParametersFindDynamicParametersByOptionUrl(id, categoryId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
